(function () {
  'use strict';

  window.LoantiCartDeliveryState = window.LoantiCartDeliveryState || {
    termsAccepted: false,
    deliveryType: null,
    pickupSelected: false
  };

  var STORAGE_KEY = 'loanti_delivery_method';
  var STATE_SESSION_KEY = 'loanti_cart_delivery_state_v2';
  var ATTR_KEY = 'Metoda dostawy';
  var DEBOUNCE_MS = 300;

  var METHOD_VALUES = {
    address: 'Dostawa na adres',
    pickup: 'Punkty odbioru i paczkomaty'
  };

  var LEGACY_ADDRESS = ['DOSTAWA DO DOMU', 'Home delivery', 'Dostawa do domu'];
  var LEGACY_PICKUP = ['Punkty odbioru', 'Pickup points'];

  var METHOD_PRICE_SUMMARY = {
    address: {
      from: 'od 19,90 zł',
      lines: 'InPost 19,90 zł • DPD 24,90 zł'
    },
    pickup: {
      from: 'od 11,90 zł',
      lines: 'Orlen 11,90 zł • InPost/DPD 14,90 zł'
    }
  };

  var TILE_ICONS = {
    address: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 3l7 6v11a1 1 0 0 1-1 1h-5v-7H11v7H6a1 1 0 0 1-1-1V9l7-6z"/></svg>',
    pickup: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>'
  };

  var patchTimer = null;
  var cartObservers = new WeakMap();
  var cartCheckTimer = null;
  var pickupPollTimer = null;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getCartRoot(root) {
    if (!root || root === document) {
      return document.getElementById('CartDrawer') || document.getElementById('CartPageForm');
    }

    if (root.id === 'CartDrawer' || root.id === 'CartPageForm') {
      return root;
    }

    if (root.querySelector) {
      return root.querySelector('#CartDrawer') || root.querySelector('#CartPageForm');
    }

    return null;
  }

  function getDrawerRoot(root) {
    return getCartRoot(root);
  }

  function forEachCartRoot(callback) {
    var cartPage = document.getElementById('CartPageForm');
    if (cartPage) {
      callback(cartPage);
    }
  }

  function getDeliveryMount(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return null;
    }

    return cartRoot.querySelector('[data-loanti-cart-delivery-mount="1"]');
  }

  function relocateToMount(cartRoot, node) {
    var mount = getDeliveryMount(cartRoot);
    if (mount && node && !mount.contains(node)) {
      mount.appendChild(node);
    }
  }

  function getCartForm(cartRoot) {
    if (!cartRoot) {
      return null;
    }

    return cartRoot.id === 'CartPageForm'
      ? cartRoot
      : cartRoot.querySelector('#CartDrawerForm');
  }

  function getStoredMethod() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      return value === 'address' || value === 'pickup' ? value : '';
    } catch (error) {
      return '';
    }
  }

  function isGenericMethodLabel(value) {
    var text = normalizeText(value);
    return (
      text === METHOD_VALUES.address ||
      text === METHOD_VALUES.pickup ||
      LEGACY_ADDRESS.indexOf(text) !== -1 ||
      LEGACY_PICKUP.indexOf(text) !== -1
    );
  }

  function hasPickupInCartAttributes(cart) {
    if (!cart || !cart.attributes) {
      return false;
    }

    var attrs = cart.attributes;
    var keys = Object.keys(attrs);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var lower = key.toLowerCase();
      var val = normalizeText(attrs[key]);

      if (!val || val.length < 3 || isGenericMethodLabel(val)) {
        continue;
      }

      if (
        lower.indexOf('globe') !== -1 ||
        lower.indexOf('pickup') !== -1 ||
        lower.indexOf('parcel') !== -1 ||
        lower.indexOf('locker') !== -1 ||
        lower.indexOf('paczkomat') !== -1 ||
        lower.indexOf('point') !== -1 ||
        lower.indexOf('odbior') !== -1 ||
        lower.indexOf('delivery') !== -1 ||
        lower.indexOf('dostaw') !== -1
      ) {
        return true;
      }

      if (/paczkomat\s+[A-Z0-9]{3,}/i.test(val)) {
        return true;
      }

      if (/\d{2}-\d{3}/.test(val) && /,|\d+\s+[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]/i.test(val)) {
        return true;
      }
    }

    return false;
  }

  function getGlobeScope(root) {
    var cartRoot = getCartRoot(root);
    if (!cartRoot) {
      return null;
    }

    return (
      cartRoot.querySelector('[data-loanti-globe-delivery="1"]') ||
      findGlobeRoot(cartRoot)
    );
  }

  function hasPickupAddressInTile(tile) {
    if (!tile) {
      return false;
    }

    var text = normalizeText(tile.textContent);
    if (!text || text === METHOD_VALUES.pickup || text.length < METHOD_VALUES.pickup.length + 10) {
      return false;
    }

    if (/\d{2}-\d{3}/.test(text)) {
      return true;
    }

    if (/,/.test(text) && text.length > METHOD_VALUES.pickup.length + 15) {
      return true;
    }

    return /paczkomat|orlen|dpd|inpost|p\.p\.|punkt|ul\.|al\./i.test(text);
  }

  function loantiHasSelectedPickupPoint(root) {
    if (window.__loantiPickupCached) {
      return true;
    }

    var cartRoot = getCartRoot(root);
    if (!cartRoot) {
      return false;
    }

    if (textLooksLikeSelectedPickupPoint(getDeliveryOnlyText(cartRoot))) {
      return true;
    }

    var scopes = [];
    var globeScope = getGlobeScope(cartRoot);
    var mount = getDeliveryMount(cartRoot);

    if (globeScope) {
      scopes.push(globeScope);
    }
    if (mount && scopes.indexOf(mount) === -1) {
      scopes.push(mount);
    }

    var s;
    var i;
    var scope;

    for (s = 0; s < scopes.length; s++) {
      scope = scopes[s];
      if (!scope) {
        continue;
      }

      var hiddenSelectors = [
        'input[type="hidden"][name*="pickup" i]',
        'input[type="hidden"][name*="globe" i]',
        'input[type="hidden"][name*="parcel" i]',
        'input[type="hidden"][name*="locker" i]',
        'input[type="hidden"][id*="pickup" i]',
        'input[type="hidden"][id*="globe" i]'
      ];

      for (var h = 0; h < hiddenSelectors.length; h++) {
        var inputs = scope.querySelectorAll(hiddenSelectors[h]);
        for (i = 0; i < inputs.length; i++) {
          var hiddenValue = normalizeText(inputs[i].value);
          if (
            hiddenValue.length > 2 &&
            hiddenValue !== 'null' &&
            hiddenValue !== 'false' &&
            hiddenValue !== '0' &&
            !isGenericMethodLabel(hiddenValue)
          ) {
            return true;
          }
        }
      }

      if (
        scope.querySelector(
          '[data-pickup-point-id]:not([data-pickup-point-id=""]),' +
          '[data-selected-pickup-point]:not([data-selected-pickup-point=""]),' +
          '[data-pickup-point-selected="true"],' +
          '[data-globe-pickup-point]:not([data-globe-pickup-point=""]),' +
          '[data-globe-selected="true"]'
        )
      ) {
        return true;
      }

      var buttons = scope.querySelectorAll('button, a, [role="button"]');
      var hasChangeButton = false;

      for (i = 0; i < buttons.length; i++) {
        var btnText = normalizeText(buttons[i].textContent);
        if (/zmień|change|zmien/i.test(btnText) && btnText.length < 30) {
          hasChangeButton = true;
          break;
        }
      }

      if (hasChangeButton) {
        var scopeText = collectDeepText(scope);
        if (textLooksLikeSelectedPickupPoint(scopeText)) {
          return true;
        }
      }

      var pickupTile =
        scope.querySelector('[data-loanti-delivery-option="pickup"].loanti-delivery-selected') ||
        scope.querySelector('[data-loanti-delivery-option="pickup"].loanti-delivery-pending');
      if (hasPickupAddressInTile(pickupTile)) {
        return true;
      }
    }

    var form = getCartForm(cartRoot);
    if (form) {
      var attrInputs = form.querySelectorAll('input[name*="attributes"], textarea[name*="attributes"]');
      for (i = 0; i < attrInputs.length; i++) {
        var name = (attrInputs[i].name || '').toLowerCase();
        var attrValue = normalizeText(attrInputs[i].value);

        if (!attrValue || isGenericMethodLabel(attrValue)) {
          continue;
        }

        if (
          name.indexOf('pickup') !== -1 ||
          name.indexOf('globe') !== -1 ||
          name.indexOf('parcel') !== -1 ||
          name.indexOf('locker') !== -1
        ) {
          return true;
        }
      }
    }

    return false;
  }

  window.loantiHasSelectedPickupPoint = loantiHasSelectedPickupPoint;

  function saveLoantiState() {
    try {
      sessionStorage.setItem(STATE_SESSION_KEY, JSON.stringify(window.LoantiCartDeliveryState));
    } catch (error) {
      /* ignore */
    }
  }

  function loadLoantiState() {
    try {
      var raw = sessionStorage.getItem(STATE_SESSION_KEY);
      if (!raw) {
        return;
      }

      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        return;
      }

      if (typeof parsed.termsAccepted === 'boolean') {
        window.LoantiCartDeliveryState.termsAccepted = parsed.termsAccepted;
      }
      if (parsed.deliveryType === 'home' || parsed.deliveryType === 'pickup' || parsed.deliveryType === null) {
        window.LoantiCartDeliveryState.deliveryType = parsed.deliveryType;
      }
      if (typeof parsed.pickupSelected === 'boolean') {
        window.LoantiCartDeliveryState.pickupSelected = parsed.pickupSelected;
      }
    } catch (error) {
      /* ignore */
    }
  }

  function collectDeepText(root, depth) {
    if (!root) {
      return '';
    }

    depth = depth || 0;
    if (depth > 6) {
      return '';
    }

    var chunks = [normalizeText(root.textContent || '')];

    root.querySelectorAll('*').forEach(function (node) {
      if (node.shadowRoot) {
        chunks.push(collectDeepText(node.shadowRoot, depth + 1));
      }
    });

    return chunks.join(' ');
  }

  function getDeliveryOnlyText(cartRoot) {
    if (!cartRoot) {
      return '';
    }

    var sidebar = cartRoot.querySelector('.loanti-cart-page__sidebar');
    if (!sidebar) {
      return collectDeepText(getDeliveryMount(cartRoot) || cartRoot);
    }

    var clone = sidebar.cloneNode(true);
    var pricelist = clone.querySelector('.loanti-delivery-pricelist');
    if (pricelist) {
      pricelist.remove();
    }

    return collectDeepText(clone);
  }

  function textLooksLikeSelectedPickupPoint(text) {
    if (!text) {
      return false;
    }

    if (/paczkomat\s+[A-Z0-9]{3,}/i.test(text)) {
      return true;
    }

    if (/paczkomat/i.test(text) && /\d{2}-\d{3}/.test(text) && /zmień|zmien|change/i.test(text)) {
      return true;
    }

    if (/orlen/i.test(text) && /\d{2}-\d{3}/.test(text) && /zmień|zmien|change/i.test(text)) {
      return true;
    }

    if (/zmień|zmien|change/i.test(text) && /,\s*\d{2}-\d{3}/.test(text)) {
      return true;
    }

    if (/,\s*\d{2}-\d{3}/.test(text) && /ul\.|al\.|os\.|pl\.|zachodnia|dalików/i.test(text)) {
      return true;
    }

    return false;
  }

  function detectPickupPointVisible(cartRoot) {
    if (window.__loantiPickupCached || loantiHasSelectedPickupPoint(cartRoot)) {
      return true;
    }

    var deliveryText = getDeliveryOnlyText(cartRoot);
    if (textLooksLikeSelectedPickupPoint(deliveryText)) {
      return true;
    }

    var areas = [];
    var mount = getDeliveryMount(cartRoot);
    var globe = getGlobeScope(cartRoot);

    if (mount) {
      areas.push(mount);
    }
    if (globe && areas.indexOf(globe) === -1) {
      areas.push(globe);
    }

    var i;
    for (i = 0; i < areas.length; i++) {
      if (textLooksLikeSelectedPickupPoint(collectDeepText(areas[i]))) {
        return true;
      }
    }

    return false;
  }

  function markPickupPointConfirmed(cartRoot) {
    window.LoantiCartDeliveryState.deliveryType = 'pickup';
    window.LoantiCartDeliveryState.pickupSelected = true;
    saveLoantiState();

    if (cartRoot) {
      markSelectedTile(cartRoot, 'pickup');
      hideError(cartRoot);
      syncCheckoutState(cartRoot);
    }
  }

  function startPickupPointPoll(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    if (pickupPollTimer) {
      clearInterval(pickupPollTimer);
    }

    var attempts = 0;
    pickupPollTimer = setInterval(function () {
      attempts += 1;
      rebuildStateFromDom(cartRoot);
      schedulePickupCartCheck();

      if (window.LoantiCartDeliveryState.pickupSelected || attempts >= 40) {
        clearInterval(pickupPollTimer);
        pickupPollTimer = null;
      }
    }, 500);
  }

  function stopPickupPointPoll() {
    if (pickupPollTimer) {
      clearInterval(pickupPollTimer);
      pickupPollTimer = null;
    }
  }
  function getDeliverySearchRoot(cartRoot) {
    if (!cartRoot) {
      return null;
    }

    return (
      getDeliveryMount(cartRoot) ||
      cartRoot.querySelector('.loanti-cart-page__delivery') ||
      cartRoot.querySelector('[data-loanti-globe-delivery="1"]') ||
      getGlobeScope(cartRoot) ||
      cartRoot
    );
  }

  function syncTermsFromDom(cartRoot) {
    if (!cartRoot) {
      return;
    }

    var termsCheckbox = cartRoot.querySelector('.cart__terms-checkbox');
    if (termsCheckbox) {
      window.LoantiCartDeliveryState.termsAccepted = termsCheckbox.checked;
    } else {
      window.LoantiCartDeliveryState.termsAccepted = true;
    }
  }

  function rebuildStateFromDom(cartRoot) {
    loadLoantiState();
    syncTermsFromDom(cartRoot);

    if (!cartRoot) {
      saveLoantiState();
      return;
    }

    var pickupPointVisible = detectPickupPointVisible(cartRoot);
    var searchRoot = getDeliverySearchRoot(cartRoot);
    var addressTile = searchRoot ? searchRoot.querySelector('[data-loanti-delivery-option="address"]') : null;
    var pickupTile = searchRoot ? searchRoot.querySelector('[data-loanti-delivery-option="pickup"]') : null;
    var addressSelected =
      addressTile &&
      (addressTile.classList.contains('loanti-delivery-selected') ||
        addressTile.getAttribute('aria-selected') === 'true' ||
        addressTile.getAttribute('aria-checked') === 'true' ||
        !!addressTile.querySelector('input[type="radio"]:checked'));
    var pickupSelectedTile =
      pickupTile &&
      (pickupTile.classList.contains('loanti-delivery-selected') ||
        pickupTile.classList.contains('loanti-delivery-pending') ||
        pickupTile.getAttribute('aria-selected') === 'true' ||
        pickupTile.getAttribute('aria-checked') === 'true' ||
        !!pickupTile.querySelector('input[type="radio"]:checked'));

    if (pickupPointVisible) {
      window.LoantiCartDeliveryState.deliveryType = 'pickup';
      window.LoantiCartDeliveryState.pickupSelected = true;
      saveLoantiState();
      return;
    }

    if (addressSelected && !pickupSelectedTile) {
      window.LoantiCartDeliveryState.deliveryType = 'home';
      window.LoantiCartDeliveryState.pickupSelected = false;
      saveLoantiState();
      return;
    }

    if (pickupSelectedTile) {
      window.LoantiCartDeliveryState.deliveryType = 'pickup';
      window.LoantiCartDeliveryState.pickupSelected = false;
      saveLoantiState();
      return;
    }

    if (window.LoantiCartDeliveryState.deliveryType === 'pickup') {
      if (pickupPointVisible) {
        window.LoantiCartDeliveryState.pickupSelected = true;
      }
      saveLoantiState();
      return;
    }

    if (window.LoantiCartDeliveryState.deliveryType === 'home') {
      saveLoantiState();
      return;
    }

    var stored = getStoredMethod();
    if (stored === 'address') {
      window.LoantiCartDeliveryState.deliveryType = 'home';
      window.LoantiCartDeliveryState.pickupSelected = false;
    } else if (stored === 'pickup') {
      window.LoantiCartDeliveryState.deliveryType = 'pickup';
      window.LoantiCartDeliveryState.pickupSelected = false;
    }

    saveLoantiState();
  }

  function syncDeliveryStateFromDom(cartRoot) {
    rebuildStateFromDom(cartRoot);
  }

  function canCheckout() {
    var state = window.LoantiCartDeliveryState;

    if (!state.termsAccepted) {
      return false;
    }

    if (state.deliveryType === 'home') {
      return true;
    }

    if (state.deliveryType === 'pickup' && state.pickupSelected === true) {
      return true;
    }

    return false;
  }

  function getCheckoutBlockReason() {
    var state = window.LoantiCartDeliveryState;

    if (!state.termsAccepted) {
      return { ok: false, code: 'terms', message: 'Zaakceptuj regulamin.' };
    }

    if (!state.deliveryType) {
      return { ok: false, code: 'delivery', message: 'Wybierz metodę dostawy.' };
    }

    if (state.deliveryType === 'pickup' && !state.pickupSelected) {
      return { ok: false, code: 'pickup', message: 'Wybierz punkt odbioru.' };
    }

    return { ok: false, code: 'delivery', message: 'Wybierz metodę dostawy.' };
  }

  function setDeliveryHome(cartRoot) {
    stopPickupPointPoll();
    window.LoantiCartDeliveryState.deliveryType = 'home';
    window.LoantiCartDeliveryState.pickupSelected = false;
    window.__loantiPickupCached = false;
    saveLoantiState();

    if (cartRoot) {
      markSelectedTile(cartRoot, 'address');
    }
  }

  function setDeliveryPickup(cartRoot, pickupSelected) {
    window.LoantiCartDeliveryState.deliveryType = 'pickup';
    window.LoantiCartDeliveryState.pickupSelected = !!pickupSelected;
    saveLoantiState();

    if (!cartRoot) {
      return;
    }

    if (pickupSelected) {
      stopPickupPointPoll();
      markSelectedTile(cartRoot, 'pickup');
    } else {
      markPickupPending(cartRoot);
      startPickupPointPoll(cartRoot);
    }
  }

  function handleSidebarDeliveryClick(event, cartRoot) {
    if (
      event.target.closest('[data-loanti-cart-checkout], .cart__checkout, .loanti-delivery-pricelist, .loanti-cart-cross-sell')
    ) {
      return;
    }

    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    var i;
    var node;
    var text;

    for (i = 0; i < path.length; i++) {
      node = path[i];
      if (!node || typeof node.textContent !== 'string') {
        continue;
      }

      text = normalizeText(node.textContent);

      if (
        text === 'DOSTAWA DO DOMU' ||
        text === METHOD_VALUES.address ||
        (textMatchesAddress(text) && text.length <= 60)
      ) {
        persistSelection('address');
        setDeliveryHome(cartRoot);
        hideError(cartRoot);
        syncCheckoutState(cartRoot);
        return;
      }
    }

    for (i = 0; i < path.length; i++) {
      node = path[i];
      if (!node || typeof node.textContent !== 'string') {
        continue;
      }

      text = normalizeText(node.textContent);

      if (textMatchesPickup(text) && text.length <= 120) {
        persistSelection('pickup');
        setDeliveryPickup(cartRoot, detectPickupPointVisible(cartRoot));
        syncCheckoutState(cartRoot);
        break;
      }
    }

    window.setTimeout(function () {
      rebuildStateFromDom(cartRoot);
      if (detectPickupPointVisible(cartRoot)) {
        markPickupPointConfirmed(cartRoot);
      } else {
        syncCheckoutState(cartRoot);
      }
      schedulePickupCartCheck();
    }, 500);

    window.setTimeout(function () {
      rebuildStateFromDom(cartRoot);
      if (detectPickupPointVisible(cartRoot)) {
        markPickupPointConfirmed(cartRoot);
      }
      schedulePickupCartCheck();
    }, 1500);

    window.setTimeout(function () {
      rebuildStateFromDom(cartRoot);
      if (detectPickupPointVisible(cartRoot)) {
        markPickupPointConfirmed(cartRoot);
      }
      schedulePickupCartCheck();
    }, 3000);
  }

  function bindSidebarDeliveryClicks(cartRoot) {
    var sidebar = cartRoot.querySelector('.loanti-cart-page__sidebar');
    if (!sidebar || sidebar.getAttribute('data-loanti-sidebar-bound') === '1') {
      return;
    }

    sidebar.setAttribute('data-loanti-sidebar-bound', '1');
    sidebar.addEventListener(
      'click',
      function (event) {
        handleSidebarDeliveryClick(event, cartRoot);
      },
      true
    );
  }

  function dedupeLoantiNodes(drawer) {
    drawer.querySelectorAll(
      '.loanti-delivery-free, [data-loanti-free-shipping], [data-loanti-prices-added], ' +
      '[data-loanti-cart-shipping], [data-loanti-cart-delivery], .loanti-cart-shipping, .loanti-cart-delivery'
    ).forEach(function (node) {
      node.remove();
    });

    drawer.querySelectorAll('.loanti-delivery-prices-panel').forEach(function (node) {
      if (!node.closest('[data-loanti-globe-delivery="1"]')) {
        node.remove();
      }
    });

    drawer.querySelectorAll('[data-loanti-delivery-error="1"]').forEach(function (node, index) {
      if (index > 0) {
        node.remove();
      }
    });

    drawer.querySelectorAll('[data-loanti-delivery-option]').forEach(function (tile) {
      tile.querySelectorAll('.loanti-tile-head').forEach(function (head, index) {
        if (index > 0) {
          head.remove();
        }
      });

      tile.querySelectorAll('.loanti-delivery-radio').forEach(function (radio, index) {
        if (index > 0) {
          radio.remove();
        }
      });

      tile.querySelectorAll('.loanti-method-from').forEach(function (from, index) {
        if (index > 0) {
          from.remove();
        }
      });

      tile.querySelectorAll('.loanti-method-prices').forEach(function (prices, index) {
        if (index > 0) {
          prices.remove();
        }
      });
    });
  }

  function isTopLevelDeliveryTile(tile, globeRoot) {
    var parent = tile.parentElement;

    while (parent && parent !== globeRoot) {
      if (parent.hasAttribute('data-loanti-delivery-option')) {
        return false;
      }
      parent = parent.parentElement;
    }

    return true;
  }

  function dedupeDeliveryTiles(globeRoot) {
    ['address', 'pickup'].forEach(function (method) {
      var tiles = Array.prototype.slice.call(
        globeRoot.querySelectorAll('[data-loanti-delivery-option="' + method + '"]')
      );

      var keep = null;

      tiles.forEach(function (tile) {
        if (tile.closest('[data-loanti-delivery-option="' + method + '"]') !== tile) {
          tile.removeAttribute('data-loanti-delivery-option');
          tile.removeAttribute('data-loanti-tile-layout');
          tile.removeAttribute('data-loanti-globe-tile');
          tile.classList.remove('loanti-globe-tile');
          return;
        }

        if (!keep) {
          keep = tile;
          return;
        }

        tile.removeAttribute('data-loanti-delivery-option');
        tile.removeAttribute('data-loanti-tile-layout');
        tile.removeAttribute('data-loanti-globe-tile');
        tile.classList.remove('loanti-globe-tile', 'loanti-delivery-selected', 'loanti-delivery-pending');
        tile.querySelectorAll(
          '.loanti-tile-head, .loanti-method-prices, .loanti-delivery-radio, .loanti-method-from'
        ).forEach(function (node) {
          node.remove();
        });
      });
    });
  }

  function textMatchesAddress(text) {
    var normalized = normalizeText(text);
    if (normalized === METHOD_VALUES.address) {
      return true;
    }
    return LEGACY_ADDRESS.indexOf(normalized) !== -1;
  }

  function textMatchesPickup(text) {
    var normalized = normalizeText(text);
    if (normalized === METHOD_VALUES.pickup) {
      return true;
    }
    return LEGACY_PICKUP.indexOf(normalized) !== -1;
  }

  function findLeafWithText(root, matcher) {
    var match = null;

    root.querySelectorAll('*').forEach(function (element) {
      if (
        element.closest('.loanti-tile-head, .loanti-method-prices, [data-loanti-tile-label]') ||
        element.hasAttribute('data-loanti-tile-label') ||
        element.classList.contains('loanti-tile-head')
      ) {
        return;
      }

      var text = normalizeText(element.textContent);
      if (!text || !matcher(text)) {
        return;
      }

      if (!match || text.length <= normalizeText(match.textContent).length) {
        match = element;
      }
    });

    return match;
  }

  function findTileWrapper(labelElement, footer) {
    var node = labelElement;

    for (var depth = 0; depth < 10 && node && node !== footer; depth++) {
      if (node.matches('button, [role="button"], label, a, input[type="radio"], input[type="checkbox"], [tabindex]')) {
        return node;
      }

      if (node.parentElement) {
        var parent = node.parentElement;
        var parentText = normalizeText(parent.textContent);

        if (
          parent.contains(labelElement) &&
          parentText.length < 140 &&
          parent.querySelector('svg, img, [class*="icon"]')
        ) {
          return parent;
        }
      }

      node = node.parentElement;
    }

    return labelElement.parentElement || labelElement;
  }

  function replaceVisibleLabel(element, nextLabel, matcher) {
    var updated = false;

    element.querySelectorAll('*').forEach(function (child) {
      if (child.children.length > 0) {
        return;
      }

      var text = normalizeText(child.textContent);
      if (text && (matcher(text) || text === nextLabel)) {
        child.textContent = nextLabel;
        updated = true;
      }
    });

    if (!updated) {
      var ownText = normalizeText(element.textContent);
      if (ownText && ownText.length < 100 && (matcher(ownText) || ownText === nextLabel)) {
        element.textContent = nextLabel;
      }
    }
  }

  function searchGlobeRoot(searchRoot, cartRoot) {
    if (!searchRoot) {
      return null;
    }

    var existing = searchRoot.querySelector('[data-loanti-globe-delivery="1"]');
    if (existing) {
      relocateToMount(cartRoot, existing);
      return existing;
    }

    var appBlocks = searchRoot.querySelectorAll('shopify-app-block, [id*="globe" i], [class*="globe" i], [data-globe]');
    if (appBlocks.length) {
      var appRoot = appBlocks[appBlocks.length - 1];
      relocateToMount(cartRoot, appRoot);
      return appRoot;
    }

    var homeLabel = findLeafWithText(searchRoot, textMatchesAddress);
    var pickupLabel = findLeafWithText(searchRoot, textMatchesPickup);

    if (!homeLabel && !pickupLabel) {
      return null;
    }

    var nodes = [homeLabel, pickupLabel].filter(Boolean);
    var root = nodes[0];

    nodes.forEach(function (start) {
      var current = start;

      while (current && current !== searchRoot) {
        var containsAll = nodes.every(function (node) {
          return current.contains(node);
        });

        if (containsAll) {
          root = current;
        }

        current = current.parentElement;
      }
    });

    relocateToMount(cartRoot, root);
    return root;
  }

  function findGlobeRoot(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return null;
    }

    var mount = getDeliveryMount(cartRoot);
    var pageRoot = searchGlobeRoot(mount || cartRoot, cartRoot);
    if (pageRoot) {
      return pageRoot;
    }

    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      return null;
    }

    return searchGlobeRoot(drawer.querySelector('.drawer__footer') || drawer, cartRoot);
  }

  function markSelectedTile(drawer, method) {
    drawer.querySelectorAll('[data-loanti-delivery-option]').forEach(function (tile) {
      var isSelected = method && tile.getAttribute('data-loanti-delivery-option') === method;
      tile.classList.toggle('loanti-delivery-selected', isSelected);
      tile.classList.toggle('loanti-delivery-pending', false);
    });
  }

  function markPickupPending(drawer) {
    drawer.querySelectorAll('[data-loanti-delivery-option]').forEach(function (tile) {
      var method = tile.getAttribute('data-loanti-delivery-option');
      tile.classList.toggle('loanti-delivery-selected', false);
      tile.classList.toggle('loanti-delivery-pending', method === 'pickup');
    });
  }

  function persistSelection(method) {
    if (method !== 'address' && method !== 'pickup') {
      return;
    }

    try {
      localStorage.setItem(STORAGE_KEY, method);
    } catch (error) {
      /* ignore */
    }

    if (window.theme && theme.cart && typeof theme.cart.updateAttribute === 'function') {
      theme.cart.updateAttribute(ATTR_KEY, METHOD_VALUES[method]);
    }
  }

  function hideError(drawer) {
    var error = drawer.querySelector('[data-loanti-delivery-error="1"]');
    if (error) {
      error.hidden = true;
    }
  }

  function showError(drawer, message) {
    var error = drawer.querySelector('[data-loanti-delivery-error="1"]');
    if (!error) {
      return;
    }

    error.textContent = message || 'Wybierz metodę dostawy.';
    error.hidden = false;
  }

  function selectAddress(drawer) {
    persistSelection('address');
    setDeliveryHome(drawer);
    hideError(drawer);
    syncCheckoutState(drawer);
  }

  function selectPickupIntent(drawer) {
    persistSelection('pickup');
    setDeliveryPickup(drawer, detectPickupPointVisible(drawer));
    hideError(drawer);
    syncCheckoutState(drawer);
  }

  function refreshDeliveryState(drawer) {
    rebuildStateFromDom(drawer);

    if (window.LoantiCartDeliveryState.deliveryType === 'home') {
      markSelectedTile(drawer, 'address');
    } else if (window.LoantiCartDeliveryState.deliveryType === 'pickup') {
      if (window.LoantiCartDeliveryState.pickupSelected) {
        markSelectedTile(drawer, 'pickup');
        hideError(drawer);
      } else {
        markPickupPending(drawer);
      }
      stylePickupPointBox(getGlobeScope(drawer) || getDeliveryMount(drawer) || drawer);
    } else {
      markSelectedTile(drawer, null);
    }

    syncCheckoutState(drawer);
  }

  function syncCheckoutState(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    rebuildStateFromDom(cartRoot);

    var checkoutBtn = cartRoot.querySelector('[data-loanti-cart-checkout="1"], .cart__checkout');

    if (canCheckout()) {
      hideError(cartRoot);
      if (checkoutBtn) {
        checkoutBtn.classList.remove('btn--loading');
        checkoutBtn.removeAttribute('aria-disabled');
      }
      return;
    }

    if (checkoutBtn) {
      checkoutBtn.classList.remove('btn--loading');
    }
  }

  function validateCartCheckout(cartRoot) {
    rebuildStateFromDom(cartRoot);

    if (canCheckout()) {
      return { ok: true };
    }

    return getCheckoutBlockReason();
  }

  function scrollToCheckoutIssue(cartRoot, code) {
    var target;

    if (code === 'terms') {
      target = cartRoot.querySelector('.cart__terms');
    } else {
      target =
        cartRoot.querySelector('[data-loanti-delivery-error="1"]') ||
        cartRoot.querySelector('[data-loanti-globe-delivery="1"]') ||
        cartRoot.querySelector('[data-loanti-cart-delivery-mount="1"]');
    }

    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function canProceedToCheckout(drawer) {
    return validateCartCheckout(drawer);
  }

  function blockCheckout(cartRoot, event) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return false;
    }

    rebuildStateFromDom(cartRoot);
    console.log('[Loanti Cart] checkout check', JSON.stringify(window.LoantiCartDeliveryState));

    if (canCheckout()) {
      hideError(cartRoot);
      return false;
    }

    var check = getCheckoutBlockReason();

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    showError(cartRoot, check.message);
    scrollToCheckoutIssue(cartRoot, check.code);

    if (check.code === 'terms') {
      var termsCheckbox = cartRoot.querySelector('.cart__terms-checkbox');
      if (termsCheckbox) {
        termsCheckbox.focus();
      }
    }

    var checkoutBtn = cartRoot.querySelector('.cart__checkout');
    if (checkoutBtn) {
      checkoutBtn.classList.remove('btn--loading');
    }

    return true;
  }

  function ensureRadioMarker(tile) {
    if (tile.querySelector('[data-loanti-radio="1"]')) {
      return;
    }

    var radio = document.createElement('span');
    radio.className = 'loanti-delivery-radio';
    radio.setAttribute('data-loanti-radio', '1');
    radio.setAttribute('aria-hidden', 'true');
    tile.appendChild(radio);
  }

  function ensureMethodFromPrice(tile, method) {
    var summary = METHOD_PRICE_SUMMARY[method];
    if (!summary) {
      return;
    }

    var from = tile.querySelector('[data-loanti-from-price="1"]');
    if (!from) {
      from = document.createElement('span');
      from.className = 'loanti-method-from';
      from.setAttribute('data-loanti-from-price', '1');
      tile.appendChild(from);
    }

    from.textContent = summary.from;
  }

  function ensureMethodPrices(tile, method) {
    var summary = METHOD_PRICE_SUMMARY[method];
    if (!summary) {
      return;
    }

    var prices = tile.querySelector('[data-loanti-method-prices="' + method + '"]');
    if (!prices) {
      prices = document.createElement('div');
      prices.className = 'loanti-method-prices';
      prices.setAttribute('data-loanti-method-prices', method);
      tile.appendChild(prices);
    }

    prices.textContent = summary.lines;
    ensureMethodFromPrice(tile, method);
  }

  function ensureTileIcon(method) {
    var icon = document.createElement('span');
    icon.className = 'loanti-tile-icon loanti-tile-icon--' + method;
    icon.setAttribute('data-loanti-tile-icon', '1');
    icon.innerHTML = TILE_ICONS[method] || '';
    return icon;
  }

  function ensureTileLayout(tile, method, label) {
    if (tile.getAttribute('data-loanti-tile-layout') === '1') {
      var existingLabel = tile.querySelector('[data-loanti-tile-label="1"]');
      if (existingLabel) {
        existingLabel.textContent = label;
      }
      ensureMethodPrices(tile, method);
      ensureRadioMarker(tile);
      return;
    }

    tile.setAttribute('data-loanti-tile-layout', '1');
    ensureMethodPrices(tile, method);
    ensureRadioMarker(tile);

    var head = document.createElement('div');
    head.className = 'loanti-tile-head';
    head.appendChild(ensureTileIcon(method));

    var labelSpan = document.createElement('span');
    labelSpan.className = 'loanti-tile-label';
    labelSpan.setAttribute('data-loanti-tile-label', '1');
    labelSpan.textContent = label;
    head.appendChild(labelSpan);

    tile.insertBefore(head, tile.firstChild);
  }

  function ensureDeliveryGrid(globeRoot) {
    if (globeRoot.querySelector('[data-loanti-delivery-grid="1"]')) {
      return;
    }

    var address = globeRoot.querySelector('[data-loanti-delivery-option="address"]');
    var pickup = globeRoot.querySelector('[data-loanti-delivery-option="pickup"]');
    if (!address || !pickup) {
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'loanti-delivery-grid';
    grid.setAttribute('data-loanti-delivery-grid', '1');

    var ref = address;
    ref.parentNode.insertBefore(grid, ref);
    grid.appendChild(address);
    grid.appendChild(pickup);
  }

  function ensureDeliveryHeading(globeRoot, cartRoot) {
    if (globeRoot.querySelector('[data-loanti-delivery-heading="1"]')) {
      return;
    }

    var heading = document.createElement('p');
    heading.className = 'loanti-delivery-heading';
    heading.setAttribute('data-loanti-delivery-heading', '1');
    heading.textContent = cartRoot && cartRoot.id === 'CartPageForm'
      ? 'Wybierz sposób dostawy'
      : 'DOSTAWA';

    var grid = globeRoot.querySelector('[data-loanti-delivery-grid="1"]');
    if (grid) {
      globeRoot.insertBefore(heading, grid);
      return;
    }

    globeRoot.insertBefore(heading, globeRoot.firstChild);
  }

  function stylePickupPointBox(globeRoot) {
    globeRoot.querySelectorAll('button, a, [role="button"]').forEach(function (node) {
      var text = normalizeText(node.textContent);
      if (!/^(zmień|change|zmien|zmień punkt|change point)$/i.test(text)) {
        return;
      }

      var box = node.closest('div');
      if (!box || box === globeRoot || box.hasAttribute('data-loanti-delivery-option')) {
        return;
      }

      box.classList.add('loanti-pickup-point-box');
      box.setAttribute('data-loanti-pickup-box', '1');
    });
  }

  function removeGlobeFreeNotes(globeRoot) {
    globeRoot.querySelectorAll('[data-loanti-free-note="1"], .loanti-delivery-free-note').forEach(function (node) {
      node.remove();
    });
  }

  function updateCartCountInTitle(count) {
    var el = document.querySelector('[data-loanti-cart-count]');
    if (!el) {
      return;
    }

    if (typeof count === 'number') {
      el.textContent = '(' + count + ')';
      return;
    }

    if (!window.theme || !theme.routes || !theme.routes.cart) {
      return;
    }

    fetch(theme.routes.cart)
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        el.textContent = '(' + cart.item_count + ')';
      })
      .catch(function () {
        /* ignore */
      });
  }

  function patchTile(footer, matcher, method, label) {
    var existing = footer.querySelector(
      '[data-loanti-delivery-option="' + method + '"][data-loanti-tile-layout="1"]'
    );
    if (existing) {
      ensureTileLayout(existing, method, label);
      return existing;
    }

    var labelElement = findLeafWithText(footer, matcher);
    if (!labelElement) {
      return null;
    }

    var tile = findTileWrapper(labelElement, footer);
    if (tile.closest('[data-loanti-delivery-option]')) {
      tile = tile.closest('[data-loanti-delivery-option]');
    }

    tile.classList.add('loanti-globe-tile');
    tile.setAttribute('data-loanti-delivery-option', method);
    tile.setAttribute('data-loanti-globe-tile', method);
    replaceVisibleLabel(tile, label, matcher);
    ensureTileLayout(tile, method, label);
    return tile;
  }

  function ensureDeliveryError(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    if (cartRoot.querySelector('[data-loanti-delivery-error="1"]')) {
      return;
    }

    var error = document.createElement('p');
    error.className = 'loanti-delivery-error';
    error.setAttribute('data-loanti-delivery-error', '1');
    error.setAttribute('role', 'alert');
    error.hidden = true;

    var pricelist = cartRoot.querySelector('.loanti-delivery-pricelist');
    var checkoutWrapper = cartRoot.querySelector('.cart__checkout-wrapper');
    var mount = getDeliveryMount(cartRoot);

    if (pricelist) {
      pricelist.insertAdjacentElement('beforebegin', error);
    } else if (checkoutWrapper) {
      checkoutWrapper.insertAdjacentElement('beforebegin', error);
    } else if (mount) {
      mount.insertAdjacentElement('afterend', error);
    } else {
      cartRoot.appendChild(error);
    }
  }

  function patchDeliveryUI(cartRoot, globeRoot) {
    dedupeLoantiNodes(cartRoot);
    removeGlobeFreeNotes(globeRoot);
    dedupeDeliveryTiles(globeRoot);
    globeRoot.classList.add('loanti-globe-delivery');
    globeRoot.setAttribute('data-loanti-globe-delivery', '1');
    globeRoot.setAttribute('data-loanti-delivery-prices', '1');

    ensureDeliveryGrid(globeRoot);
    ensureDeliveryHeading(globeRoot, cartRoot);

    var tiles = globeRoot.querySelectorAll(':scope > .loanti-delivery-grid [data-loanti-delivery-option], :scope > [data-loanti-delivery-option]');
    if (!tiles.length) {
      tiles = globeRoot.querySelectorAll('[data-loanti-delivery-option]');
    }

    tiles.forEach(function (tile) {
      if (tile.closest('[data-loanti-delivery-option]') !== tile) {
        return;
      }

      if (!isTopLevelDeliveryTile(tile, globeRoot)) {
        tile.removeAttribute('data-loanti-delivery-option');
        tile.removeAttribute('data-loanti-tile-layout');
        return;
      }

      var method = tile.getAttribute('data-loanti-delivery-option');
      if (method) {
        ensureTileLayout(tile, method, METHOD_VALUES[method]);
      }
    });

    dedupeLoantiNodes(cartRoot);
    stylePickupPointBox(globeRoot);
    ensureDeliveryError(cartRoot);
    refreshDeliveryState(cartRoot);
    ensureCheckoutObserver(cartRoot);
    bindDeliveryMountEvents(cartRoot);
    syncCheckoutState(cartRoot);
    updateCartCountInTitle();
  }

  function patchTiles(cartRoot, globeRoot) {
    patchTile(cartRoot, textMatchesAddress, 'address', METHOD_VALUES.address);
    patchTile(cartRoot, textMatchesPickup, 'pickup', METHOD_VALUES.pickup);
    refreshDeliveryState(cartRoot);
  }

  function schedulePickupCartCheck() {
    if (cartCheckTimer) {
      clearTimeout(cartCheckTimer);
    }

    cartCheckTimer = setTimeout(function () {
      if (!window.theme || !theme.routes || !theme.routes.cart) {
        return;
      }

      fetch(theme.routes.cart)
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          window.__loantiPickupCached = hasPickupInCartAttributes(cart);
          if (window.__loantiPickupCached) {
            forEachCartRoot(function (cartRoot) {
              markPickupPointConfirmed(cartRoot);
            });
            return;
          }
          forEachCartRoot(function (cartRoot) {
            refreshDeliveryState(cartRoot);
          });
        })
        .catch(function () {
          /* ignore */
        });
    }, 200);
  }

  function ensureCheckoutObserver(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    var targets = [];
    var globeScope = getGlobeScope(cartRoot);
    var mount = getDeliveryMount(cartRoot);

    if (globeScope) {
      targets.push(globeScope);
    }
    if (mount && targets.indexOf(mount) === -1) {
      targets.push(mount);
    }

    targets.forEach(function (target) {
      if (!target || target.getAttribute('data-loanti-checkout-observer') === '1') {
        return;
      }

      target.setAttribute('data-loanti-checkout-observer', '1');
      var checkoutObserver = new MutationObserver(function () {
        window.setTimeout(function () {
          rebuildStateFromDom(cartRoot);
          if (detectPickupPointVisible(cartRoot)) {
            markPickupPointConfirmed(cartRoot);
          } else {
            refreshDeliveryState(cartRoot);
          }
        }, 150);
      });
      checkoutObserver.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
        attributeFilter: ['class', 'aria-selected', 'aria-checked', 'value', 'data-selected']
      });
    });
  }

  function bindDeliveryMountEvents(cartRoot) {
    var mount = getDeliveryMount(cartRoot);
    if (!mount || mount.getAttribute('data-loanti-mount-bound') === '1') {
      return;
    }

    mount.setAttribute('data-loanti-mount-bound', '1');

    mount.addEventListener(
      'click',
      function (event) {
        var tile = event.target.closest('[data-loanti-delivery-option]');
        if (tile) {
          var method = tile.getAttribute('data-loanti-delivery-option');
          if (method === 'address') {
            persistSelection('address');
            setDeliveryHome(cartRoot);
          } else if (method === 'pickup') {
            persistSelection('pickup');
            window.setTimeout(function () {
              rebuildStateFromDom(cartRoot);
              if (window.LoantiCartDeliveryState.deliveryType !== 'pickup') {
                setDeliveryPickup(cartRoot, detectPickupPointVisible(cartRoot));
              }
              syncCheckoutState(cartRoot);
            }, 250);
            return;
          }
        }

        window.setTimeout(function () {
          rebuildStateFromDom(cartRoot);
          syncCheckoutState(cartRoot);
        }, 250);
      },
      true
    );
  }

  function bindCheckoutFeedback(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    if (cartRoot.getAttribute('data-loanti-checkout-feedback') === '1') {
      return;
    }

    cartRoot.setAttribute('data-loanti-checkout-feedback', '1');

    var termsCheckbox = cartRoot.querySelector('.cart__terms-checkbox');
    if (termsCheckbox) {
      window.LoantiCartDeliveryState.termsAccepted = termsCheckbox.checked;
      termsCheckbox.addEventListener('change', function () {
        window.LoantiCartDeliveryState.termsAccepted = termsCheckbox.checked;
        saveLoantiState();
        syncCheckoutState(cartRoot);
      });
    } else {
      window.LoantiCartDeliveryState.termsAccepted = true;
      saveLoantiState();
    }

    bindSidebarDeliveryClicks(cartRoot);
    bindDeliveryMountEvents(cartRoot);
    ensureCheckoutObserver(cartRoot);
    rebuildStateFromDom(cartRoot);
    schedulePickupCartCheck();
    syncCheckoutState(cartRoot);
  }

  function ensureCartPageCheckoutGuard(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    ensureDeliveryError(cartRoot);
    bindCheckoutFeedback(cartRoot);
  }

  function bindCheckout(cartRoot) {
    /* Checkout obsługuje wyłącznie loanti-cart-page.js — bez podwójnej blokady */
  }

  function bindDrawerEvents(cartRoot) {
    if (cartRoot.getAttribute('data-loanti-delivery-bound') === '1') {
      return;
    }

    cartRoot.setAttribute('data-loanti-delivery-bound', '1');

    cartRoot.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-loanti-delivery-option]');
      if (!tile || !cartRoot.contains(tile)) {
        return;
      }

      var method = tile.getAttribute('data-loanti-delivery-option');

      if (method === 'address') {
        selectAddress(cartRoot);
        return;
      }

      if (method === 'pickup') {
        selectPickupIntent(cartRoot);
        schedulePickupCartCheck();
        window.setTimeout(function () {
          syncCheckoutState(cartRoot);
        }, 300);
      }
    }, false);
  }

  function patchCartRoot(cartRoot) {
    if (!cartRoot || cartRoot.id !== 'CartPageForm') {
      return;
    }

    if (cartRoot.getAttribute('data-loanti-patching') === '1') {
      return;
    }

    cartRoot.setAttribute('data-loanti-patching', '1');

    var cartObserver = cartObservers.get(cartRoot);
    if (cartObserver) {
      cartObserver.disconnect();
    }

    try {
      var globeRoot = findGlobeRoot(cartRoot);
      if (!globeRoot) {
        ensureCartPageCheckoutGuard(cartRoot);
        return;
      }

      var needsTiles = !globeRoot.querySelector('[data-loanti-delivery-option="address"], [data-loanti-delivery-option="pickup"]');
      if (needsTiles) {
        patchTiles(cartRoot, globeRoot);
        globeRoot.setAttribute('data-loanti-delivery-patched', '1');
      }

      patchDeliveryUI(cartRoot, globeRoot);
      bindDrawerEvents(cartRoot);
      ensureCartPageCheckoutGuard(cartRoot);
      schedulePickupCartCheck();
    } finally {
      cartRoot.removeAttribute('data-loanti-patching');

      if (cartObserver && cartRoot.getAttribute('data-loanti-observer-bound') === '1') {
        cartObserver.observe(cartRoot, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  window.LoantiCartDeliveryPatch = function (root) {
    if (!root || root === document) {
      forEachCartRoot(patchCartRoot);
      return;
    }

    var cartRoot = getCartRoot(root);
    if (!cartRoot) {
      return;
    }

    patchCartRoot(cartRoot);
  };

  window.LoantiCartDeliveryInit = window.LoantiCartDeliveryPatch;

  function schedulePatch(cartRoot) {
    if (patchTimer) {
      clearTimeout(patchTimer);
    }

    patchTimer = setTimeout(function () {
      var activeCartRoot = getCartRoot(cartRoot);
      if (!activeCartRoot) {
        return;
      }

      var globeRoot = findGlobeRoot(activeCartRoot);
      var hasAddress = globeRoot && globeRoot.querySelector('[data-loanti-delivery-option="address"]');
      var hasPickup = globeRoot && globeRoot.querySelector('[data-loanti-delivery-option="pickup"]');

      if (!hasAddress || !hasPickup) {
        window.LoantiCartDeliveryPatch(activeCartRoot);
        return;
      }

      dedupeLoantiNodes(activeCartRoot);
      if (globeRoot) {
        dedupeDeliveryTiles(globeRoot);
        stylePickupPointBox(globeRoot);
      }
      refreshDeliveryState(activeCartRoot);
      schedulePickupCartCheck();
      syncCheckoutState(activeCartRoot);
    }, DEBOUNCE_MS);
  }

  function setupObserver(cartRoot) {
    if (cartRoot.getAttribute('data-loanti-observer-bound') === '1') {
      return;
    }

    cartRoot.setAttribute('data-loanti-observer-bound', '1');

    var cartObserver = new MutationObserver(function () {
      if (cartRoot.getAttribute('data-loanti-patching') === '1') {
        return;
      }

      var globeRoot = findGlobeRoot(cartRoot);
      if (!globeRoot) {
        return;
      }

      var hasAddress = globeRoot.querySelector('[data-loanti-delivery-option="address"]');
      var hasPickup = globeRoot.querySelector('[data-loanti-delivery-option="pickup"]');

      if (!hasAddress || !hasPickup) {
        schedulePatch(cartRoot);
        return;
      }

      schedulePatch(cartRoot);
    });

    cartObservers.set(cartRoot, cartObserver);

    cartObserver.observe(cartRoot, {
      childList: true,
      subtree: true
    });
  }

  function boot() {
    forEachCartRoot(function (cartRoot) {
      loadLoantiState();
      ensureCartPageCheckoutGuard(cartRoot);
      patchCartRoot(cartRoot);
      setupObserver(cartRoot);
      schedulePickupCartCheck();
      window.setTimeout(schedulePickupCartCheck, 1500);
    });

    if (!window.__loantiPickupFocusBound) {
      window.__loantiPickupFocusBound = true;
      window.addEventListener('focus', function () {
        forEachCartRoot(function (cartRoot) {
          rebuildStateFromDom(cartRoot);
          schedulePickupCartCheck();
          if (detectPickupPointVisible(cartRoot)) {
            markPickupPointConfirmed(cartRoot);
          }
        });
      });
    }
  }

  function bootWithDelay() {
    window.LoantiCartDeliveryPatch(document);
    setTimeout(function () {
      forEachCartRoot(function (cartRoot) {
        dedupeLoantiNodes(cartRoot);
        var globeRoot = findGlobeRoot(cartRoot);
        if (globeRoot) {
          dedupeDeliveryTiles(globeRoot);
        }
        refreshDeliveryState(cartRoot);
        syncCheckoutState(cartRoot);
      });
      schedulePickupCartCheck();
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('ajaxProduct:added', bootWithDelay);
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart && typeof event.detail.cart.item_count === 'number') {
      updateCartCountInTitle(event.detail.cart.item_count);
    }
    bootWithDelay();
  });
  document.addEventListener('cart:open', bootWithDelay);
  document.addEventListener('drawerOpen.CartDrawer', bootWithDelay);

  window.LoantiValidateCartCheckout = validateCartCheckout;
  window.LoantiCanCheckout = canCheckout;
  window.LoantiSyncCartCheckoutState = syncCheckoutState;
  window.LoantiRebuildCartDeliveryState = rebuildStateFromDom;
  window.LoantiShowCartCheckoutError = function (cartRoot, check) {
    if (!cartRoot || !check) {
      return;
    }

    showError(cartRoot, check.message);
    scrollToCheckoutIssue(cartRoot, check.code);

    if (check.code === 'terms') {
      var termsCheckbox = cartRoot.querySelector('.cart__terms-checkbox');
      if (termsCheckbox) {
        termsCheckbox.focus();
      }
    }
  };
  window.LoantiBlockCartCheckout = blockCheckout;
})();
